import React from 'react';
import { ArcButton, ArcStack } from '@src/core/ui';
import { useNavigate } from 'react-router-dom';
import Sections from './status/sections';
import Popups from './status/popups';
import { useDispatch } from 'react-redux';
import { setSelectedOrder, setOrderFormData } from './redux';

const OrdersPage: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCreateMission = () => {
    dispatch(setOrderFormData(null));
    navigate('create');
  };

  React.useEffect(() => {
    return () => { 
      dispatch(setSelectedOrder(null));
      dispatch(setOrderFormData(null)); 
    };
  }, [dispatch]);

  return (
    <React.Fragment>
      <ArcStack flex={1} padding={2} marginTop={1} sx={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        <ArcButton.brand 
          size='large' 
          onClick={handleCreateMission} sx={{ width: '208px', flexShrink: 0 }}>
        CREATE MISSION
        </ArcButton.brand>

        <ArcStack sx={{ flex: 1, minHeight: 0, overflow: 'hidden' }}>
          <Sections />
        </ArcStack>

        <Popups />
      </ArcStack>
    </React.Fragment>
  );
};

export default OrdersPage;